export default {
  title: 'Umsatzübersicht',
  description: 'Umsätze im gewählten Zeitraum — zur Abrechnungsprüfung mit diesem Restaurant.',
  filters: {
    period: 'Zeitraum',
  },
  presets: {
    this_month: 'Dieser Monat',
    last_month: 'Letzter Monat',
    last_30_days: 'Letzte 30 Tage',
    this_year: 'Dieses Jahr',
  },
  fields: {
    orders_count: 'Bestellungen',
    net_sales: 'Nettoumsatz',
    sales_tax: 'Umsatzsteuer',
    gross_sales: 'Bruttoumsatz',
    delivery_fee_tax: 'Liefergebühr (Steuer)',
    delivery_fee_gross: 'Liefergebühr (brutto)',
    tips_gross: 'Trinkgeld (brutto)',
    total: 'Gesamt',
  },
  kpi: {
    before_tax: 'ohne Steuer',
    tips: 'für das Restaurant erhalten',
    owed_to_restaurant: 'dem Restaurant zustehend',
  },
  table: {
    title: 'Aufschlüsselung',
    subtitle: '{{range}} · Alle Beträge in {{currency}}',
    field: 'Position',
    amount: 'Betrag',
    empty: 'Keine Bestellungen im gewählten Zeitraum',
    footnote:
      'Nettoumsatz ohne Steuer; Bruttoumsatz mit Steuer · Gesamt ist abzüglich Plattformgebühren und entspricht daher nicht dem vom Kunden gezahlten Betrag · Rückerstattungen und Rückbuchungen sind gegengerechnet · Beträge in {{currency}}',
  },
  buttons: {
    export_csv: 'CSV exportieren',
    refresh: 'Aktualisieren',
    retry: 'Erneut versuchen',
  },
  errors: {
    failed_to_load: {
      title: 'Umsatzübersicht konnte nicht geladen werden',
      description: 'Beim Laden des Berichts ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    },
  },
};
